import React from 'react';
import { Modal } from './Modal';
interface Props {
  open: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  open,
  onClose
}: Props) {
  return <Modal open={open} onClose={onClose} title="Privacy Policy" data-id="element-36">
      <div className="space-y-4" data-id="element-37">
        <p className="text-xs text-gray-500" data-id="element-38">Last updated: January 2025</p>

        <section data-id="element-39">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-40">
            1. Information We Collect
          </h3>
          <p data-id="element-41">
            We collect personal information that you voluntarily provide when
            you request a quote or use our debt relief services. This may
            include your name, email address, phone number, postal address, and
            information about your debts.
          </p>
        </section>

        <section data-id="element-42">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-43">
            2. How We Use Your Information
          </h3>
          <p data-id="element-44">
            Your information is used to match you with debt relief providers, to
            evaluate your eligibility for our program, to communicate with you
            about your inquiry, and to improve our services. We may also use
            your contact information to send you relevant offers.
          </p>
        </section>

        <section data-id="element-45">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-46">
            3. Sharing of Information
          </h3>
          <p data-id="element-47">
            We may share your information with our network of partner debt
            relief companies, legal service providers, and trusted third parties
            who help us deliver our services. We do not sell your information to
            unrelated third parties for their own marketing without your
            consent.
          </p>
        </section>

        <section data-id="element-48">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-49">
            4. Communications &amp; TCPA Consent
          </h3>
          <p data-id="element-50">
            By submitting your information, you consent to be contacted by
            phone, text message, and email — including via automated technology
            — at the number and email you provided, even if you are on a Do Not
            Call list. Consent is not a condition of any purchase.
          </p>
        </section>

        <section data-id="element-51">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-52">
            5. Cookies &amp; Tracking
          </h3>
          <p data-id="element-53">
            Our site uses cookies and similar technologies to analyze traffic,
            personalize content, and measure the effectiveness of our
            advertising. You can disable cookies in your browser settings.
          </p>
        </section>

        <section data-id="element-54">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-55">6. Data Security</h3>
          <p data-id="element-56">
            We use industry-standard safeguards including SSL encryption to
            protect your personal information. However, no method of
            transmission over the internet is 100% secure.
          </p>
        </section>

        <section data-id="element-57">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-58">7. Your Rights</h3>
          <p data-id="element-59">
            You may request access, correction, or deletion of your personal
            information at any time by contacting us. Residents of California
            and certain other states may have additional rights under applicable
            law.
          </p>
        </section>

        <section data-id="element-60">
          <h3 className="font-semibold text-gray-900 mb-1" data-id="element-61">8. Contact Us</h3>
          <p data-id="element-62">
            For any questions about this Privacy Policy, please contact us at{' '}
            <a href="mailto:privacy@example.com" className="text-blue-700 underline" data-id="element-63">
              privacy@example.com
            </a>
            .
          </p>
        </section>
      </div>
    </Modal>;
}